import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Inject, Component, Output, Input, EventEmitter, ViewChild, ElementRef, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'asap-time-picker',
    template: `
        <mat-form-field class="w-100 asap-timepicker">
            <mat-label>Horário do evento</mat-label>
            <input #txtH (change)="change()" type="number" min="0" max="23" id="hora" matInput>
            <div class="time-divider mt-1 text-center">:</div>
            <input #txtM (change)="change()" type="number" min="0" max="59" id="minuto" matInput>
        </mat-form-field>
    `,
    styleUrls: ['./asap.component.css']
})
export class AsapTimePickerComponent implements OnChanges {

    ngModelValue: string;

    @ViewChild("txtH") txtH: ElementRef;
    @ViewChild("txtM") txtM: ElementRef;

    @Output()
    ngModelChange = new EventEmitter<string>();

    @Input()
    get ngModel() {
        return this.ngModelValue;
    }

    set ngModel(val) {
        this.ngModelValue = val;
        this.ngModelChange.emit(this.ngModelValue);
        this.modelToElements();
    }

    ngOnChanges(changes: SimpleChanges) {
        this.modelToElements();
    }

    private modelToElements() {
        let H = this.ngModelValue.split(":");

        if (this.txtH.nativeElement.value != H[0]) {
            this.txtH.nativeElement.value = H[0];
        };

        if (this.txtM.nativeElement.value != H[1]) {
            this.txtM.nativeElement.value = H[1];
        };
    }

    public change() {
        let H: any = "00";
        let M: any = "00";

        if (this.txtH.nativeElement.value) {
            H = this.txtH.nativeElement.value;
            if (H < 10) H = "0" + parseInt(H);
        }

        if (this.txtM.nativeElement.value) {
            M = this.txtM.nativeElement.value;
            if (M < 10) M = "0" + parseInt(M);
        }

        this.ngModel = H + ":" + M;
    }

}


// WEBPACK FOOTER //
// ./src/app/@core/lib/asap-time-picker.component.ts